import TableList from "@components/templates/tablelist";
import {
    HttpWorkDetailList,
    HttpWorkDetailListSubmit,
    HttpWorkDetailListCancel,
    HttpGetWorkorderSpan,
    HttpReprocessError,
    HttpIgnoreError,
    HttpWorkRevokeAudit,
} from "@/service/workorder";
import { mapState, mapGetters } from "vuex";
import comIndex from "./update/index";
import mixin from "./mixin";
export default {
    mixins: [TableList, mixin],
    components: {
        comIndex,
    },
    data() {
        return {
            // totals: 0,
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_workOrderPlanStatus: null,
                },
            },
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            datename: "",
            datetime: "",
            Plugins: { show: true },
            initData: "",
            spanTabs: { show: true },
        };
    },
    // created() {
    // this.timehandle()
    // },
    methods: {
        ajaxRequest: HttpWorkDetailList,
        handleParams(params) {
            if (params.search.EQ_workOrderPlanStatus == -99999) {
                params.search.NE_errorStatus = 99999;
                delete params.search.EQ_workOrderPlanStatus;
            }

            return params;
        },
        interceptRequest(params) {
            return this.handleParams(params);
        },
        spanAjaxRequest: () => {
            return HttpGetWorkorderSpan({
                isManage: 0,
            });
        },

        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning("请选择至少一条数据");
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: "doublieworkorUpdate",
                        params: { type: "add" },
                        query: { difference: "detail" },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: "doublieworkorUpdate",
                        params: { type: "edit" },
                        query: { id: params, difference: "detail" },
                    });
                    break;
                case "query":
                    this.operate = {
                        title: "查看",
                        show: true,
                        width: 1200,
                        component: "comIndex",
                        activeid: params,
                        querytype: "query",
                        differencetype: "detail",
                        alertbox: "alertbox",
                        showFooter: false,
                    };
                    break;
                case "queryBlank":
                    var url = this.$router.resolve({
                        name: "doublieworkorUpdate",
                        params: { type: "query" },
                        query: { id: params, difference: "detail" },
                    });
                    window.open(url.href, "_blank");
                    break;
                case "submitbox":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "提交",
                        width: 460,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注原因",
                                required: false,
                            },
                        ],
                        ajaxRequest: HttpWorkDetailListSubmit,
                    };
                    break;
                case "cancel":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "取消",
                        width: 460,
                        params: { id: params },
                        formdata: [
                            {
                                tag: "vTextarea",
                                key: "remark",
                                span: 24,
                                label: "备注原因",
                            },
                        ],
                        ajaxRequest: HttpWorkDetailListCancel,
                        on: {
                            "on-success": (res) => {
                                // console.log(res)
                            },
                        },
                    };
                    break;
                case "revoke":
                    this.operate = {
                        show: true,
                        alert: "error",
                        title: "撤销审核",
                        width: 460,
                        params: { id: params },
                        ajaxRequest: HttpWorkRevokeAudit,
                    };
                    break;
                case "export":
                    this.handleWebfs(
                        process.env.VUE_APP_APIURL_FBB +
                            "/api/v2/ServiceWorkOrderPlan/clientExport",
                        this.formData,
                        "download"
                    );
                    break;
                case "errorReprocess":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: this.$t("global.common.error_process", {
                            defaultValue: "异常重处理",
                        }),
                        params: { id: params },
                        ajaxRequest: HttpReprocessError,
                    };
                    break;
                case "errorIgnore":
                    this.operate = {
                        show: true,
                        alert: "success",
                        title: this.$t("global.common.error_ignore", {
                            defaultValue: "忽略异常",
                        }),
                        params: { id: params },
                        ajaxRequest: HttpIgnoreError,
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, workOrderPlanStatus, errorStatus } = row;
            return [
                {
                    label: "提交",
                    show: workOrderPlanStatus == 0 || workOrderPlanStatus == 15,
                    params: id,
                    operate: "submitbox",
                },
                {
                    label: "查看",
                    show: true,
                    params: id,
                    operate: "query",
                },
                {
                    label: "编辑",
                    show: workOrderPlanStatus == 0 || workOrderPlanStatus == 15,
                    params: id,
                    operate: "edit",
                },
                {
                    label: "取消",
                    show:
                        workOrderPlanStatus == 0 ||
                        workOrderPlanStatus == 10 ||
                        workOrderPlanStatus == 15 ||
                        workOrderPlanStatus == 20,
                    params: id,
                    operate: "cancel",
                },
                {
                    label: "撤销审核",
                    show: workOrderPlanStatus == 10,
                    params: id,
                    operate: "revoke",
                },
                {
                    label: this.$t("global.common.reprocess", {
                        defaultValue: "重处理",
                    }),
                    show: errorStatus != 99999,
                    params: id,
                    operate: "errorReprocess",
                },
                {
                    label: this.$t("global.common.ignoreError", {
                        defaultValue: "忽略异常",
                    }),
                    show: errorStatus != 99999,
                    params: id,
                    operate: "errorIgnore",
                },
            ];
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getProductList",
            "getWorkTypeList",
            "getTransferWarehouse",
        ]),
        TabsData() {
            return [
                {
                    name: "全部",
                    key: "EQ_workOrderPlanStatus",
                    val: null,
                    spanKey: "allNum",
                },
                {
                    name: "待审核",
                    key: "EQ_workOrderPlanStatus",
                    val: 10,
                    spanKey: "pendingNum",
                },
                {
                    name: "审批拒回",
                    key: "EQ_workOrderPlanStatus",
                    val: 15,
                    spanKey: "refuseNum",
                },
                {
                    name: "待处理",
                    key: "EQ_workOrderPlanStatus",
                    val: 20,
                    spanKey: "approvedNum",
                },
                {
                    name: "处理中",
                    key: "EQ_workOrderPlanStatus",
                    val: 30,
                    spanKey: "processingNum",
                },
                {
                    name: "已完成",
                    key: "EQ_workOrderPlanStatus",
                    val: 70,
                    spanKey: "completeNum",
                },
                {
                    name: "异常",
                    key: "EQ_workOrderPlanStatus",
                    val: -99999,
                    spanKey: "errorNum",
                },
            ];
        },
        ToolsData() {
            return [
                {
                    name: "新增",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "导出",
                    operate: "export",
                },
            ];
        },
        SearchsData() {
            return [
                {
                    label: "事务处理计划单号",
                    tag: "vInput",
                    key: "EQ_workOrderPlanNo",
                    show: true,
                },
                {
                    label: "来源单号",
                    tag: "vInput",
                    key: "EQ_sourceNo",
                    show: true,
                },
                {
                    label: "状态",
                    tag: "vSelect",
                    key: "EQ_workOrderPlanStatus",
                    options: this.orderStatusList,
                    show: true,
                },
                {
                    label: "异常状态",
                    tag: "vSelect",
                    key: "EQ_errorStatus",
                    options: this.errorStatusList,
                    show: true,
                },
                {
                    label: "仓库",
                    tag: "vSelect",
                    key: "EQ_orgWarehouseId",
                    options: this.getTransferWarehouse,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "项目",
                    tag: "vSelect",
                    key: "EQ_lineId",
                    options: this.getProductList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "关联单据类型",
                    tag: "vSelect",
                    key: "EQ_relationOrderTypeId",
                    options: this.getContactOrderList,
                    props: {
                        filterable: true,
                    },
                },
                {
                    label: "关联单据号",
                    tag: "vInput",
                    key: "EQ_orderNo",
                },
                {
                    label: this.$t('fbb.transfer.istakepictures', { defaultValue: "是否拍照" }),
                    tag: "vSelect",
                    key: "EQ_hasPicture",
                    options: [
                        {
                            label: this.$t('tms.ship.correct', { defaultValue: "是" }),
                            value: 1,
                        },
                        {
                            label: this.$t('tms.ship.deny', { defaultValue: "否" }),
                            value: 0,
                        },
                    ],
                },
                {
                    label: "事务类型包含",
                    tag: "vSelect",
                    key: "EQ_serviceWorkOrderPlanItemList.workOrderTypeId",
                    options: this.getWorkTypeList,
                    props: {
                        filterable: true,
                    },
                },
            ];
        },
        columns() {
            return [
                {
                    type: "selection",
                    width: 40,
                    align: "center",
                    formName: "id",
                },
                {
                    title: "操作",
                    width: 90,
                    render: this.getOperateNodes,
                },
                {
                    title: "事务处理计划单号/来源单号",
                    sortable: true,
                    render: (h, { row }) => {
                        return (
                            <div>
                                <div>
                                    <a
                                        onClick={this.handleOperates.bind(
                                            this,
                                            row.id,
                                            "query"
                                        )}
                                    >
                                        {row.workOrderPlanNo}
                                    </a>
                                    <a
                                        onClick={this.handleOperates.bind(
                                            this,
                                            row.id,
                                            "queryBlank"
                                        )}
                                    >
                                        <vIcon
                                            class="margin-left-10 font-14"
                                            type="ios-browsers-outline"
                                        />
                                    </a>
                                </div>
                                <div>{row.sourceNo || "--"}</div>
                                <div>
                                    <span style="color:red;">
                                        {this.findRenderLabel(
                                            this.errorStatusList,
                                            row.errorStatus
                                        )}{" "}
                                    </span>{" "}
                                </div>
                            </div>
                        );
                    },
                },
                {
                    title: "关联单据类型/关联单号/项目",
                    render: (h, { row }) => {
                        const relation = row.relationOrderTypeId;
                        const json =
                            this.getContactOrderList.filter((item) => {
                                return relation == item.value;
                            })[0] || {};
                        return (
                            <div>
                                <div>{json.label || "--"}</div>
                                <div>{row.orderNo || "--"}</div>
                                <div>
                                    {this.findRenderLabel(
                                        this.getProductList,
                                        row.lineId
                                    ) || "--"}
                                </div>
                            </div>
                        );
                    },
                },
                {
                    title: "状态",
                    width: 100,
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.orderStatusList,
                            row.workOrderPlanStatus,
                            "label",
                            true
                        ),
                },
                {
                    title: "仓库",
                    render: (h, { row }) =>
                        this.findRenderLabel(
                            this.getTransferWarehouse,
                            row.orgWarehouseId
                        ),
                },
                {
                    title: "更新时间",
                    key: "updatedAt",
                },
            ];
        },
    },
};
